/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BoneTag
 */
export interface BoneTag {
    /**
     * 
     * @type {string}
     * @memberof BoneTag
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BoneTag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BoneTag
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof BoneTag
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BoneTag
     */
    groupsBoneTagIds?: Array<string>;
}

/**
 * Check if a given object implements the BoneTag interface.
 */
export function instanceOfBoneTag(value: object): value is BoneTag {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BoneTagFromJSON(json: any): BoneTag {
    return BoneTagFromJSONTyped(json, false);
}

export function BoneTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoneTag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'description': json['description'] == null ? undefined : json['description'],
        'groupsBoneTagIds': json['groupsBoneTagIds'] == null ? undefined : json['groupsBoneTagIds'],
    };
}

export function BoneTagToJSON(json: any): BoneTag {
    return BoneTagToJSONTyped(json, false);
}

export function BoneTagToJSONTyped(value?: BoneTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'imageId': value['imageId'],
        'description': value['description'],
        'groupsBoneTagIds': value['groupsBoneTagIds'],
    };
}

